module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("field-popup " + (_vm.isActive ? 'field-popup--active' : '')),
    attrs: {
      "data-id": _vm.id,
      "id": ("field-popup-" + _vm.id)
    }
  }, [(!_vm.$store.state.isMobile) ? _c('div', {
    staticClass: "field-popup__action-message"
  }, [_c('icon', {
    attrs: {
      "name": "exclamation"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('fieldPopup.tabOrClickToContinue')))])], 1) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "field-popup__header"
  }, [(_vm.type !== 'dropdown') ? _c('span', {
    staticClass: "field-popup__header__text"
  }, [_vm._v(_vm._s(_vm.title === _vm.$t('fieldPopup.untitled') ? _vm.$t('fieldPopup.addYourField', {
    type: _vm.$t(("fieldPopup.type." + _vm.type))
  }) : _vm.title))]) : _c('span', {
    staticClass: "field-popup__header__text"
  }, [_vm._v(_vm._s(_vm.$t('fieldPopup.selectAnOption')))]), _vm._v(" "), (_vm.required === 'true') ? _c('span', {
    staticClass: "field-popup__header__label"
  }, [_c('icon', {
    attrs: {
      "name": "asterisk",
      "height": "10",
      "width": "10"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('fieldPopup.requiredField')))])], 1) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "field-popup__close",
    on: {
      "click": _vm.closeFieldPopup
    }
  }, [_c('icon', {
    attrs: {
      "name": "close",
      "width": "16",
      "height": "16"
    }
  })], 1)]), _vm._v(" "), (_vm.type == 'signature') ? _c('div', {
    staticClass: "field-popup__content"
  }, [_c('tabs', {
    attrs: {
      "type": "signature"
    }
  }, [(_vm.config.company_signature_format_drawn === '1') ? _c('tab', {
    attrs: {
      "name": _vm.$t('fieldPopup.signature.draw'),
      "property": "drawn",
      "id": "1",
      "iconName": "pencil"
    }
  }, [_c('signature-box', {
    attrs: {
      "type": "draw",
      "activate-confirm-button": _vm.activateConfirmButton
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.config.company_signature_format_typed === '1') ? _c('tab', {
    attrs: {
      "name": _vm.$t('fieldPopup.signature.type'),
      "property": "typed",
      "id": "2",
      "iconName": "font",
      "hasInput": "true"
    }
  }, [_c('signature-box', {
    attrs: {
      "type": "type",
      "activate-confirm-button": _vm.activateConfirmButton
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.config.company_signature_format_upload === '1') ? _c('tab', {
    attrs: {
      "name": _vm.$t('fieldPopup.signature.upload'),
      "property": "uploaded",
      "id": "3",
      "iconName": "cloud-upload"
    }
  }, [_c('fine-uploader', {
    attrs: {
      "activate-confirm-button": _vm.activateConfirmButton,
      "field-id": _vm.id,
      "options": _vm.signatureUploadOpts,
      "type": "imageUpload"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type == 'text') ? _c('div', {
    staticClass: "field-popup__content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldText),
      expression: "fieldText"
    }],
    ref: "input",
    staticClass: "field-popup__field-text",
    domProps: {
      "value": (_vm.fieldText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fieldText = $event.target.value
      }, _vm.updateFieldText]
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.type == 'textarea') ? _c('div', {
    staticClass: "field-popup__content"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldText),
      expression: "fieldText"
    }],
    ref: "input",
    staticClass: "field-popup__field-textarea",
    domProps: {
      "value": (_vm.fieldText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fieldText = $event.target.value
      }, _vm.updateFieldText]
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.type == 'dropdown') ? _c('div', {
    staticClass: "field-popup__content field-popup__content--dropdown"
  }, _vm._l((_vm.field.dropdown_choices), function(choice) {
    return _c('div', {
      class: {
        selected: _vm.field.content === choice
      },
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          return _vm.selectDropdownChoice($event)
        }
      }
    }, [_vm._v(_vm._s(choice))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.type == 'date') ? _c('div', {
    staticClass: "field-popup__content"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "grid__item grid__item--6"
  }, [_c('datepicker', {
    attrs: {
      "inline": true,
      "field-id": _vm.id,
      "language": _vm.$i18n.locale
    },
    model: {
      value: (_vm.pickedDate),
      callback: function($$v) {
        _vm.pickedDate = $$v
      },
      expression: "pickedDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid__item grid__item--6"
  }, [(_vm.pickedDate) ? _c('h1', {
    staticClass: "field-popup__date-text"
  }, [_vm._v(_vm._s(_vm.pickedDate))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.type == 'upload') ? _c('div', {
    staticClass: "field-popup__content"
  }, [_c('fine-uploader', {
    attrs: {
      "activate-confirm-button": _vm.activateConfirmButton,
      "field-id": _vm.id,
      "options": _vm.documentUploadOpts,
      "type": "documentUpload"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field-popup__buttons"
  }, [(_vm.type === 'signature' || _vm.type == 'upload' || _vm.type === 'date') ? _c('app-button', {
    attrs: {
      "text": _vm.$t('functional.confirm'),
      "iconName": "check",
      "action": _vm.confirm,
      "isActive": _vm.isButtonActive,
      "classList": "button--cta float-right"
    }
  }) : _c('app-button', {
    attrs: {
      "text": _vm.$store.getters.footerNextButtonText(),
      "action": _vm.nextAction,
      "classList": "button--cta float-right"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24f3aff6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FieldPopup.vue
// module id = 1046
// module chunks = 1